import { render, staticRenderFns } from "./CafeteriaViewEquipments.vue?vue&type=template&id=6556f138"
import script from "./CafeteriaViewEquipments.vue?vue&type=script&lang=js"
export * from "./CafeteriaViewEquipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports